var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "mx-auto", attrs: { id: "pl_ts-footer" } }),
      _vm._v(" "),
      _c("script2", [
        _vm._v(
          "\n    _tsRatingConfig = {\n    tsid: 'XC513E98EB1F05BB5183FD80883A561F8',\n    variant: 'testimonial',\n    reviews: '5',\n    betterThan: '4.5',\n    richSnippets: 'on',\n    backgroundColor: '#ffdc0f',\n    linkColor: '#000000',\n    fontFamily: 'Verdana',\n    fontColor: '#000000',\n    reviewMinLength: '12',\n    quotationMarkColor: '#ffffff',\n    responsive: { variant: 'floating' }\n    };\n\n    var scripts = document.getElementsByTagName('SCRIPT'),\n    //me = scripts[scripts.length - 1];\n    mee = document.getElementById('pl_ts-footer');\n    var _ts = document.createElement('SCRIPT');\n    _ts.type = 'text/javascript';\n    _ts.async = true;\n    _ts.src = '//widgets.trustedshops.com/reviews/tsSticker/tsSticker.js';\n    //me.parentNode.insertBefore(_ts, me);\n    mee.insertBefore(_ts, mee.childNodes[0]);\n    _tsRatingConfig.script = _ts;\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }